import { useNavigate } from "@tanstack/react-router"

import { WebappRoutes } from "@/features/webapp/config/routes"

interface OnboardingLockWaitingProps {
  remainingLabel: string | null
  title?: string
  subtitle?: string
}

/** Full-page gate when the user opens a locked tab via direct URL. */
export function OnboardingLockWaiting({
  remainingLabel,
  title = "Your Report’s Almost Here!",
  subtitle = "We’re preparing your personalized reading. Chat with advisors in the meantime — your reading unlocks when the timer ends.",
}: OnboardingLockWaitingProps) {
  const navigate = useNavigate()

  return (
    <div className="flex min-h-[60dvh] flex-col items-center justify-center gap-6 px-2">
      <div className="flex flex-col items-center gap-2 text-center">
        <h2 className="font-display text-2xl font-medium text-purple-light">{title}</h2>
        <p className="font-body text-base text-purple-light/70">{subtitle}</p>
      </div>

      <div className="flex flex-col items-center rounded-2xl bg-purple-light/10 px-6 pb-2 pt-3">
        <p className="font-body text-[10px] font-medium uppercase text-purple-light/70">
          Unlocks in
        </p>
        <p className="font-display text-[40px] font-bold text-white">
          {remainingLabel ?? "30:00"}
        </p>
      </div>

      <button
        type="button"
        onClick={() => navigate({ to: WebappRoutes.ADVISORS })}
        className="flex h-14 w-full items-center justify-center rounded-full bg-gradient-to-b from-peach to-purple-accent font-body text-base font-semibold text-white"
      >
        Got it
      </button>
    </div>
  )
}
